import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartCompare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChartCompare"><Path d="M3.5 3.5V20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 18.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 18.5V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 18.5V5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 18.5V9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChartCompare;
